import { useState } from "react";
import I18n from "../../../../../core/localization/I18n";
import { Button, ButtonTypes } from "../../../Button";
import { UiSizes } from "@flightpath/coreui/dist/enums";
import { ColDef, GetRowIdParams } from "ag-grid-community";
import { AppGrid } from "../../../../../core/grids/builder/directorBuilder/grids/base/AppGrid_view";
import "./_select-header-step.scss";

export const SelectHeaderStep: React.FC<{
  data: string[][];
  onContinue: (headerIndex: number) => void;
  onBack: () => void;
}> = ({ data, onContinue, onBack }) => {
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);

  const columnDefs: ColDef[] = Array.from({ length: data[0]?.length || 0 }, (_, i) => ({
    field: `col${i}`,
    headerName: `Column ${i + 1}`,
    minWidth: 150,
    sortable: false,
    filter: false
  }));

  columnDefs.push({
    field: "selected",
    headerName: "",
    width: 50,
    resizable: false,
    pinned: "left",
    editable: false,
    checkboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true
  });

  const rowData = data.map((row, rowIndex) => {
    const rowObj: Record<string, any> = {};
    row.forEach((cell, cellIndex) => {
      rowObj[`col${cellIndex}`] = cell;
    });
    rowObj["id"] = rowIndex;
    return rowObj;
  });

  return (
    <div className="col d-flex flex-column">
      <div className="row">
        <div className="col my-2">
          <h2>{I18n.t("phrases.selectHeaderStep")}</h2>
          {I18n.t("phrases.selectHeaderRow", {
            defaultValue: "Click on the row that contains your column headers."
          })}
        </div>
      </div>

      <div className="row">
        <div className="col insight-tab-content__space-filler" style={{ height: "500px", width: "100%" }}>
          <AppGrid
            getRowId={(params: GetRowIdParams) => {
              return params.data.id;
            }}
            rowData={rowData}
            columnDefs={columnDefs}
            shouldTrackSelectedCell={true}
            rowSelection="single"
            onRowSelected={params => {
              setSelectedRowIndex(params.node.rowIndex);
            }}
          />
        </div>
      </div>

      <div className="button-container row d-flex justify-content-between my-4 px-3 py-3">
        <Button className="col-3" type={ButtonTypes.OUTLINE_SECONDARY} size={UiSizes.LG} onClick={onBack}>
          {I18n.t("phrases.back")}
        </Button>
        <div className="col-3"></div>
        <Button
          className="col-6"
          type={ButtonTypes.PRIMARY}
          onClick={() => selectedRowIndex !== null && onContinue(selectedRowIndex)}
          isDisabled={selectedRowIndex === null}
        >
          <span> {I18n.t("phrases.continue")}</span>
        </Button>
      </div>
    </div>
  );
};
